/* eslint-disable */
import _ from 'underscore';
import template from '@bingads-webui-static-legacy/bulk-edit/template/shared/changeRsaAutoAssets.pug';
import viewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeRsaAutoAssets';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var view = BaseView.extend({
  initialize: function (options) {
    this.options = options || ({});
    BaseView.prototype.initialize.apply(this, arguments);
    this.template = template;
    this.entity = options.entity;
    this.ko_model = new viewModel(this.model);
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    return this;
  },
  setAction: function () {
    var action = {
      Actions: [{
        '@odata.type': '#Model.TextAction',
        Property: 'CampaignSettings/RSAAutoGeneratedAssetsEnabled',
        ActionType: 'Set',
        Value: this.ko_model.isRsaAutoAssetsSettingChecked().toString(),
        SearchString: '',
        Options: 'None'
      }]
    };
    this.model.set('BatchAction', action);
    this.model.set('Entity', 'Campaign');
  },
  getIdFilter: function () {
    return filterHelper.getIdFilter(this.grid, 'Campaign');
  },
  getProgressText: function () {
    return i18n.getString('BulkEdit_Campaigns_ProgressText');
  },
  formatErrors: function (rows) {
    if (rows) {
      _.each(rows, function (item) {
        item.Entity = _.find(item.EntityKey, function (item) {
          return item.Key === 'CampaignName';
        });
        item.data = [];
        item.data.push({
          value: item.Entity && item.Entity.Value ? item.Entity.Value : '',
          isHtml: false
        });
      });
    }
    return rows;
  }
});
export default view;

